/* eslint-disable import/prefer-default-export */
export const showVotesPercent = ({ votes, total }) => {
  let percent = 0;
  if (votes.length !== 0) {
    percent = (100 * Number(votes.length)) / Number(total);
  }

  return `${percent % 1 !== 0 ? percent.toFixed(1) : percent}%`;
};
